import { render, staticRenderFns } from "./BracketNode.vue?vue&type=template&id=adffebba&scoped=true"
import script from "./BracketNode.vue?vue&type=script&lang=js"
export * from "./BracketNode.vue?vue&type=script&lang=js"
import style0 from "./BracketNode.vue?vue&type=style&index=0&id=adffebba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adffebba",
  null
  
)

export default component.exports